module.exports = __webpack_public_path__ + "img/SC.d1cb1ed5.png";